import styled, { css } from 'styled-components';
import { Colors } from '@fourthwall/components';
export const ImagesContent = styled.div `
  position: relative;
  width: 200px;
  height: 140px;
`;
const imageStyles = css `
  position: absolute;
  object-fit: cover;
  border-radius: 2px;
  overflow: hidden;
`;
export const PrimaryImage = styled.img `
  ${imageStyles};
  z-index: 1;
  aspect-ratio: 62 / 72;
  width: 62px;
  left: 16px;
  top: 14px;
`;
export const SecondaryImage = styled.img `
  ${imageStyles};
  aspect-ratio: 138 / 100;
  width: 138px;
  right: 15px;
  top: 0;
`;
export const ImagesDescription = styled.div `
  position: absolute;
  font-size: 12px;
  line-height: 130%;
  letter-spacing: 0.24px;
  bottom: 0;
  width: 100%;
  color: ${Colors.GS600};
  text-align: center;

  a {
    text-decoration: underline;

    &:hover {
      color: ${Colors.GS1000};
    }
  }
`;
